import { put, call, takeLatest } from 'redux-saga/effects';
import services from '../../services';

import {
  SEARCH_CONTENT,
  SEARCH_CONTENT_SUCCESS,
  SEARCH_CONTENT_ERROR,
} from '../types/search/search';

import { SearchOutDto } from '../../types/search.dto';

function* fetchSearchResults({ payload }: { payload: SearchOutDto }): any {
  try {
    const { response, error } = yield call(services.search.search, payload);

    if (error) {
      yield put({ type: SEARCH_CONTENT_ERROR, payload: error });
    } else {
      yield put({ type: SEARCH_CONTENT_SUCCESS, payload: response });
    }
  } catch (error) {
    yield put({ type: SEARCH_CONTENT_ERROR, payload: 'Error al buscar, intenta de nuevo.' });
  }
}

export default function* searchSaga() {
  yield takeLatest<any>(SEARCH_CONTENT, fetchSearchResults);
}
